const SHORT_CODE_REGEX = /^[a-zA-Z]\d{3}$/

export const isShortCode = (text) => !!text.trim().match(SHORT_CODE_REGEX)
